import React from 'react';

// import woman image
import WomanImg from '../assets/img/hi3.png';
import resume from '../assets/img/resume.pdf'

const Hero = () => {
  return (
    <section
      id='home'
      className='lg:h-[95vh] flex items-center bg-primary lg:bg-cover lg:bg-center lg:bg-no-repeat py-32 lg:py-0'
    >
      <div className='container mx-auto h-full'>
        <div className='flex items-center h-full pt-8'>
          <div className='flex-1 flex flex-col items-center lg:items-start'>
            <p className='text-lg text-accent text-md mb-[22px]'>
              Hey, I'm Himel! 👋
            </p>
            <h1 className='text-4xl leading-[44px] md:text-5xl md:leading-tight lg:text-7xl lg:leading-[1.2] font-bold md:tracking-[-2px]'>
              I Build & Design <br /> Web Interfaces.
            </h1>
            <p className='pt-4 pb-8 md:pt-6 md:pb-12 max-w-[480px] text-lg text-center lg:text-left'>
              I Try to create beautiful responsive
              and interactive websites with help of
              frameworks. I bleed JavaScript and
              React.js with it's powers daily.
            </p>
            <button className='btn btn-md bg-accent hover:bg-secondary-hover md:btn-lg transition-all'>
              <a href='https://drive.google.com/file/d/1BygGwCPJgl07JWbaTH9zog0eLypTk4RR/view?usp=sharing' target='_blank'>Download Resume</a>
            </button>
          </div>
          <div className='hidden lg:flex flex-1 justify-end items-end h-full'>
            <img src={WomanImg} alt='' />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
